import uiEditTagModal from './edit-tag-modal'

export {
    uiEditTagModal
}